import React from "react";
import PropTypes from "prop-types";

import { Grid } from "@material-ui/core";
import { formatDate } from "utils";

import Money from "components/Money";

import { SubscriptionInformationTable } from "./components";

function Information({ loading, subscriptionInfo, ssaUrl, trialInfoText }) {
  return (
    <React.Fragment>
      {subscriptionInfo?.inTrial && (
        <div style={{ marginBottom: "1em" }}>
          {subscriptionInfo?.trialEnd && (
            <p data-test="trial-date">
              {subscriptionInfo?.after?.billingPeriod === "yearly"
                ? "Annual"
                : "Monthly"}{" "}
              billing begins after your trial ends on{" "}
              <b>{formatDate("simpleDate")(subscriptionInfo?.trialEnd)}</b>, as
              outlined in our{" "}
              <a href={ssaUrl} target="_blank" rel="noopener noreferrer">
                Subscription Services Agreement
              </a>
              . No charges today.
            </p>
          )}
          <p data-test="trial-info">{trialInfoText}</p>
        </div>
      )}
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <SubscriptionInformationTable
            loading={loading}
            title="Current subscription"
            subscription={subscriptionInfo?.before}
          />
        </Grid>

        {subscriptionInfo?.renewal && (
          <Grid item>
            <SubscriptionInformationTable
              loading={loading}
              title="Changes on next renewal"
              subscription={subscriptionInfo?.renewal}
            />
          </Grid>
        )}

        <Grid item>
          <SubscriptionInformationTable
            loading={loading}
            title="Updated subscription"
            subscription={subscriptionInfo?.after}
          />

          {!subscriptionInfo?.inTrial && (
            <span style={{ fontSize: "0.875rem" }} data-test="billing-info">
              {subscriptionInfo?.after.nextBillingDate ? (
                <React.Fragment>
                  Next Billing on:{" "}
                  <strong>
                    {formatDate("simpleDate")(
                      subscriptionInfo?.after.nextBillingDate
                    )}
                  </strong>
                  .{"\n"}
                </React.Fragment>
              ) : (
                ""
              )}
              A prorated amount might be charged today, and an invoice will be
              emailed to you.
            </span>
          )}
          {subscriptionInfo?.coupon && (
            <div
              style={{ fontSize: "0.875rem", marginTop: "0.5em" }}
              data-test="coupon-info"
            >
              A{" "}
              <b>
                <Money currency={subscriptionInfo?.currency}>
                  {subscriptionInfo.coupon.discountAmount}
                </Money>
              </b>{" "}
              discount has been applied to your updated subscription from the
              coupon code <b>{subscriptionInfo.coupon?.id}</b>, and the total
              price shown above reflects this.
            </div>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

Information.propTypes = {
  subscriptionInfo: PropTypes.shape({
    currency: PropTypes.object,
    before: PropTypes.object,
    renewal: PropTypes.object,
    after: PropTypes.object,
    inTrial: PropTypes.bool,
    trialEnd: PropTypes.object,
    coupon: PropTypes.object,
  }),
  loading: PropTypes.bool,
  trialInfoText: PropTypes.string,
  ssaUrl: PropTypes.string,
};

Information.defaultProps = {
  subscriptionInfo: null,
  loading: false,
  trialInfoText:
    "Below is an overview of your updated subscription after your trial " +
    "ends. You can cancel anytime before your trial ends in your Account " +
    "Settings page.",
  ssaUrl: "https://www.myhubly.com/subscription-services-agreement",
};
export default Information;
